import { render, staticRenderFns } from "./BookingPositionSearchItem.vue?vue&type=template&id=655af434&scoped=true&"
import script from "./BookingPositionSearchItem.vue?vue&type=script&lang=js&"
export * from "./BookingPositionSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./BookingPositionSearchItem.vue?vue&type=style&index=0&id=655af434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655af434",
  null
  
)

export default component.exports